module.exports = __webpack_public_path__ + "static/media/agente_inbound_icon.b6967283.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/agente_inbound_icon.svg
// module id = 1778
// module chunks = 0